<template>
  <div class="content">

    <el-row class="bgW">
      <el-col :span="22">
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
          <el-form-item label="创建时间" >
            <el-date-picker
              v-model="search.date"
              type="daterange"
              class="w220"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              
            />
          </el-form-item>
          <el-form-item label="注意事项" >
            <el-input
              v-model="search.precautions"
              placeholder="注意事项"
              class="w200"
              clearable
            />
          </el-form-item>

          <el-form-item label="关联品项">
            <el-select
              v-model="search.item_ids"
              placeholder="品项模糊搜索"
              class="w200"
              filterable
              remote
              clearable
              multiple
              reserve-keyword
              :remote-method="remoteMethodItems"
            >
              <el-option
                v-for="item in options.itemsList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="关联商品">
            <el-select
              v-model="search.goods_ids"
              placeholder="商品模糊搜索"
              class="w200"
              filterable
              remote
              clearable
              multiple
              reserve-keyword
              :remote-method="remoteMethodGoods"
            >
              <el-option
                v-for="item in options.goodsList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="关联治疗医嘱">
            <el-select
              v-model="search.advice_ids"
              placeholder="医嘱模糊搜索"
              class="w200"
              filterable
              remote
              clearable
              multiple
              reserve-keyword
              :remote-method="remoteMethodcaseCont"
            >
              <el-option
                v-for="item in options.caseContentList"
                :key="item.id"
                :label="item.content"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="2" style="text-align: right;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
      </el-col>
    </el-row>

    <div class="accountCon">
      <div style="padding:0 10px 10px;">
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog('add')">新增事项</el-button>
        <el-button type="primary" size="mini" icon="el-icon-download" @click="exportData">导出</el-button>
      </div>

      <el-table
        :data="list"
        size="small"
        border
        :cell-style="$style.cellStyle"
        :header-cell-style="$style.rowClass"
      >
        <el-table-column label="序号" type="index" width="50" align="center" />
        <el-table-column label="添加时间" prop="create_time" width="180" />
        <el-table-column label="注意事项" prop="precautions" />
        <el-table-column label="关联治疗医嘱" width="230" prop="advice_contents">
        </el-table-column>
        <el-table-column label="关联品项" width="230" prop="item_names">
        </el-table-column>
        <el-table-column label="关联商品" width="230" prop="goods_names">
        </el-table-column>
        <el-table-column label="添加人" prop="operator_name" width="100" />
        <el-table-column label="操作" fixed="right" width="100" >
          <template slot-scope="{ row }">
            <span class="theme mr10" @click="openDialog('detail', row)">查看</span>
            <span class="theme mr10" @click="openDialog('edit', row)">编辑</span>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        class="page tc mt10"
        :total="page.total"
        :page.sync="page.page"
        :limit.sync="page.limit"
        @pagination="getList"
      />
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="700px"
      :close-on-click-modal="false"
      @close="resetForm"
    >
      <el-form
        ref="formRef"
        :model="form"
        label-width="150px"
        label-suffix="："
        size="mini"
        :rules="rules"
      >
        <el-form-item label="注意事项" prop="precautions">
          <el-input type="textarea" v-model="form.precautions" class="w400" placeholder="请输入" :readonly="dialogType === 'detail'"  autosize />
        </el-form-item>

        <el-form-item label="关联治疗医嘱" prop="advice_ids">
          <el-select
            v-model="form.advice_ids"
            multiple
            class="w400" 
            placeholder="请选择关联治疗医嘱"
            :disabled="dialogType === 'detail'"
            filterable
            remote
            reserve-keyword
            :remote-method="remoteMethodcaseCont"
          >
            <el-option
              v-for="item in options.caseContentList"
              :key="item.id"
              :label="item.content"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="关联品项" prop="item_ids">
          <el-select
            v-model="form.item_ids"
            multiple
            placeholder="请选择关联品项"
            :disabled="dialogType === 'detail'"
            class="w400" 
            filterable
            remote
            reserve-keyword
            :remote-method="remoteMethodItems"
          >
            <el-option
              v-for="item in options.itemsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="关联商品" prop="goods_ids">
          <el-select
            v-model="form.goods_ids"
            multiple
            placeholder="请选择关联商品"
            :disabled="dialogType === 'detail'"
            class="w400" 
            filterable
            remote
            reserve-keyword
            :remote-method="remoteMethodGoods"
          >
            <el-option
              v-for="item in options.goodsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button
          size="mini"
          type="primary"
          v-if="dialogType !== 'detail'"
          @click="submitForm"
        >
          确认保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pagination from '@/components/Pagination'
import { getCasePrecautionList, updateCasePrecaution, addCasePrecaution,caseContentList } from '@/api/goods'
import { getGoodList} from '@/api/goods'

class Page {
  total = 0
  page = 1
  limit = 10
}

class Search {
  precautions = ''
  goods_ids = []
  item_ids = []
  advice_ids = []
  date = []
}
class Options {
  goodsList = []
  itemsList = []
  caseContentList = []
}

class Form {
  id = ''
  precautions = ''
  advice_ids = []
  item_ids = []
  goods_ids = []
}

export default {
  name: 'CareList',
  components: { pagination },
  data() {
    return {
      search: new Search(),
      page: new Page(),
      options: new Options(),
      list: [],
      dialogVisible: false,
      dialogType: 'add',
      dialogTitle: '新增事项',
      form: new Form(),
      formRef: 'formRef',
      rules: {
        precautions: [
          { required: true, message: '请输入注意事项', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted() {
    this.getList();
  },
  methods: {
    remoteMethodItems(query) {
      getGoodList({ name: query,type:1,action:'search',shop_id:this.userInfo.shop_id }).then(res=>{
        this.options.itemsList = res;
      })
    },
    remoteMethodGoods(query) {
      getGoodList({ name: query,type:2, action:'search' }).then(res=>{
        this.options.goodsList = res;
      })
    },
    remoteMethodcaseCont(query) {
      caseContentList({ name: query}).then(res=>{
        this.options.caseContentList = res.data;
      })
    },
    exportData(){
       getCasePrecautionList({
        precautions: this.search.precautions,
        item_ids: this.search.item_ids.join(','),
        goods_ids: this.search.goods_ids.join(','),
        advice_ids: this.search.advice_ids.join(','),
        time_start: this.search.date && this.search.date[0],
        time_end: this.search.date && this.search.date[1],
        is_export:1
      }).then(res=>{
        window.open(res.data.url)
      })

    },
    async getList(option) {
      if (option === 'search') this.page = new Page()
      getCasePrecautionList({
        precautions: this.search.precautions,
        item_ids: this.search.item_ids.join(','),
        goods_ids: this.search.goods_ids.join(','),
        advice_ids: this.search.advice_ids.join(','),
        time_start: this.search.date && this.search.date[0],
        time_end: this.search.date && this.search.date[1],
        ...this.page
      }).then(res=>{
        this.list = res.data.list || [];
        this.page.total = res.data.total;
      })
    },

    async openDialog(type, row = {}) {
      this.dialogType = type
      this.dialogVisible = true
      this.remoteMethodGoods('');
      this.remoteMethodItems('');
      this.remoteMethodcaseCont('');
      if (type === 'add') {
        this.dialogTitle = '新增注意事项'
        this.form = new Form()
      }
      if (type === 'edit') {
        this.dialogTitle = '编辑注意事项'
        this.form = { ...row }
      }
      if (type === 'detail') {
        this.dialogTitle = '查看注意事项'
        this.form = { ...row }
      }
    },
    async submitForm() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        try {
          this.form.operator = this.userInfo.id
          if (this.dialogType === 'add') {
            await addCasePrecaution(this.form)
          } else if (this.dialogType === 'edit') {
            await updateCasePrecaution(this.form)
          }
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.getList()
        } catch (err) {
          this.$message.error(err)
        }
      })
    },

    resetForm() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>